import { css } from '@compiled/react';

import Spinner from '@atlaskit/spinner';

import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { useLoomLandAccountReady } from '@/components/signup/loom-land-opt-in/use-loom-land-account-ready';
import { useLoomLandExposure } from '@/components/signup/loom-land-opt-in/use-loom-land-exposure';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { CreateASiteText } from '../../components/create-a-site-heading';
import { Headings } from '../../components/headings';
import { SitesAreSharedSpacesText } from '../../components/sub-heading';

// Mount the experiment reader after the account update settles. Re-rendering an
// already-mounted useExperiment would retain its memoized pre-update assignment.
const LoomLandResolvedSignup = () => {
	const isRedirecting = useLoomLandExposure();

	if (isRedirecting) {
		return <LoomLandLoading />;
	}

	return (
		<>
			<Headings main={<CreateASiteText />} sub={<SitesAreSharedSpacesText />} />
			<SiteActivation useContactExpandCohortLogic />
		</>
	);
};

const LoomLandLoading = () => (
	<div css={loadingCss} data-testid="loom-exposure-loading">
		<Spinner size="large" />
	</div>
);

export const LoggedInLoomNewUser = () => {
	const accountReady = useLoomLandAccountReady();

	return (
		<LoomOverlayTemplate size="sm">
			<div css={containerCss}>
				{accountReady ? <LoomLandResolvedSignup /> : <LoomLandLoading />}
			</div>
		</LoomOverlayTemplate>
	);
};

const containerCss = css({
	display: 'grid',
	gap: '10px',
});

const loadingCss = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// Keep the modal body from collapsing while the form is held back, so the
	// spinner sits centred in roughly the space the form will occupy.
	minHeight: '200px',
});
